import { defineAction } from '~/prix'
import { z } from 'zod'
import waterSourceApplicationCreateAction from './waterSourceApplicationCreate.action.json' with { type: 'json' }
import { waterSourceApplicationObject } from '../waterSourceApplicationObject'

const waterSourceApplicationCreateDefinition = defineAction({
  ...waterSourceApplicationCreateAction,

  input: waterSourceApplicationObject
    .pick({
      id: true,
      citizenId: true,
      incentiveType: true,
      value: true,
      bankHolderName: true,
      bankHolderDocument: true,
      bankName: true,
      bankBranch: true,
      bankAccount: true,
      observation: true,
    })
    .partial({ id: true }),

  output: z.object({ id: waterSourceApplicationObject.shape.id }),
})

export default waterSourceApplicationCreateDefinition
